import React, { useEffect, useRef } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";
import { IdentityResetHero } from "@/components/identity-reset/IdentityResetHero";
import { IdentityResetSections } from "@/components/identity-reset/IdentityResetSections";
import { trackEvent } from "@/lib/pixel";

const IdentityReset = () => {
  // Fire the standard Meta ViewContent event exactly once when the visitor
  // reaches the Identity Reset page. A ref guard prevents duplicate fires
  // from React rerenders or Strict Mode double-invocation.
  const viewContentFired = useRef(false);
  useEffect(() => {
    if (viewContentFired.current) return;
    viewContentFired.current = true;
    trackEvent("ViewContent", {
      content_name: "Identity Reset",
      content_ids: ["identity-reset"],
      content_type: "product",
      value: 47,
      currency: "USD",
    });
  }, []);

  return (
    <>
      <SEOHead
        title="Identity Reset Workshop: Scripture-Rooted Teaching by Ieshia Danielle"
        description="A guided workshop to renew the beliefs and labels quietly shaping your choices. Teaching on false rest, identity drift, wire versus weights, Beliefs, Boundaries and Budget, and the Reset framework, plus guided reflection."
        canonical="https://iamieshiadanielle.com/programs/identity-reset"
        ogImage="https://vibe.filesafe.space/1787853701390843161/attachments/f5132870-2eff-4cb6-857e-02f5311e029c.jpg"
        schemaJson={[
          {
            "@type": "WebPage",
            "@id":
              "https://iamieshiadanielle.com/programs/identity-reset#webpage",
            url: "https://iamieshiadanielle.com/programs/identity-reset",
            name: "Identity Reset Workshop: Scripture-Rooted Teaching by Ieshia Danielle",
            isPartOf: { "@id": "https://iamieshiadanielle.com/#website" },
            about: { "@id": "https://iamieshiadanielle.com/#person" },
            inLanguage: "en-US",
          },
          {
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://iamieshiadanielle.com",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Programs",
                item: "https://iamieshiadanielle.com/programs",
              },
              {
                "@type": "ListItem",
                position: 3,
                name: "Identity Reset",
                item: "https://iamieshiadanielle.com/programs/identity-reset",
              },
            ],
          },
          {
            "@type": "Product",
            "@id":
              "https://iamieshiadanielle.com/programs/identity-reset#product",
            name: "Identity Reset Workshop",
            description:
              "A guided digital workshop to renew the beliefs and labels quietly shaping your choices. Around one hour of Scripture-rooted teaching covering false rest, identity drift, wire versus weights, Beliefs, Boundaries and Budget, and the Reset framework, plus guided reflection. Licensed for personal use only.",
            image:
              "https://vibe.filesafe.space/1787853701390843161/attachments/f5132870-2eff-4cb6-857e-02f5311e029c.jpg",
            brand: { "@id": "https://iamieshiadanielle.com/#organization" },
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "5",
              reviewCount: "3",
            },
            offers: {
              "@type": "Offer",
              price: "47",
              priceCurrency: "USD",
              availability: "https://schema.org/InStock",
              url: "https://iamieshiadanielle.com/programs/identity-reset",
            },
            review: [
              {
                "@type": "Review",
                reviewBody: "A weight was lifted",
                author: {
                  "@type": "Person",
                  name: "Identity Reset attendee",
                },
              },
              {
                "@type": "Review",
                reviewBody: "I realized I was not alone",
                author: {
                  "@type": "Person",
                  name: "Identity Reset attendee",
                },
              },
              {
                "@type": "Review",
                reviewBody: "It was time to do the work",
                author: {
                  "@type": "Person",
                  name: "Identity Reset attendee",
                },
              },
            ],
          },
        ]}
      />
      <div className="min-h-screen bg-[#FAF6F0] text-[#380C1E] flex flex-col font-sans w-full overflow-x-hidden">
        <Header />
        <main className="flex-1">
          <IdentityResetHero />
          <IdentityResetSections />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default IdentityReset;
